import axios from 'axios';
import { baseURL } from '../Constants';

const url = baseURL + "/steam";

export const fetchSteamProfile = async (steamId: string) => {
    try {
        const response = await axios.get(`${url}/getSteamAccount/${steamId}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};